<template>
  <div id="app">
    <SBNavBar />
    <div v-if="isAuthenticated" class="container lg:px-16 sm:px-0" style="padding-top:15px">
      <div class="sm:px-1 md:px-4">
        <router-view/>
      </div>
    </div>
    <div v-if="!isAuthenticated" class="container">
        <router-view/>
    </div>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <portal-target name="modals"></portal-target>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
  import SBNavBar from './components/SBNavBar'
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        isAuthenticated: 'auth/isAuthenticated',
        user: 'auth/user'
      })
    },
    components: {
      SBNavBar
    },
    mounted () {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish()
  },
  created () {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        // parse meta tags
        this.$Progress.parseMeta(meta)
      }
      //  start the progress bar
      this.$Progress.start()
      //  continue to next page
      next()
    })
    //  hook the progress bar to finish after we've finished moving router-view
    // eslint-disable-next-line no-unused-vars
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish()
    })
  }
  }
</script>
